import cls from 'classnames';

const styles = {
  wrapper: cls(
    'bg-gray-1 teair:bg-air-mediumBlue rounded-4 py-12 px-8 flex flex-col mx-8 max-w-screen-2xl 2xl:mx-auto drop-shadow-medium min-h-[44rem] max-h-[85vh]',
  ),
  content: cls(
    'min-h-0 flex-grow overflow-hidden bg-gray-1 text-white gap-x-12 grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-flow-col grid-rows-none hidden max-w-screen-2xl relative',
    'md:grid xl:grid-cols-4 2xl:mx-auto',
    'teair:bg-air-mediumBlue teair:text-white',
  ),
  headerText: 'text-h5 mb-6 h-6',
  currentRadio:
    'row-span-2 col-span-1 flex min-h-0 flex-col overflow-auto channel-switcher-scrollbar',
  channelsWrapperOuter:
    'relative col-span-1 lg:col-span-2 xl:col-span-3 2xl:col-span-3 row-span-2 flex min-h-0 flex-col overflow-hidden',
  channelsAndAdWrapper: 'flex min-h-0 flex-1 flex-col lg:flex-row lg:gap-x-8',
  channelsListWrapper:
    'min-h-0 min-w-0 flex-1 overflow-y-auto channel-switcher-scrollbar',
  adSlotWrapper: 'hidden shrink-0 self-start lg:block lg:w-[300px]',
  compactScreenMusicLayout: 'hidden md:block xl:hidden',
  middleScreenMusicLayout: 'hidden xl:block 2xl:hidden',
  middleScreenMusicTopRow: 'xl:grid xl:grid-cols-2 xl:gap-x-12',
  bottomTabletAdSlot:
    'channel-switcher-bottom-ad hidden shrink-0 md:block lg:hidden mt-6 min-h-[90px]',
  musicChannelsWrapperInnerMiddle: 'xl:grid xl:grid-cols-2 xl:gap-x-12',
  musicChannelsWrapperInnerXl: 'hidden 2xl:grid 2xl:grid-cols-3 2xl:gap-x-12',
  stationChannelsWrapperInner:
    'xl:grid xl:grid-cols-2 xl:gap-x-12 2xl:flex 2xl:gap-x-0 2xl:overflow-auto channel-switcher-scrollbar mb-12',
};

export const channelList = {
  wrapper: (hasXLversion: boolean) =>
    cls(
      'flex items-center p-2 hover:bg-black hover:teair:bg-air-deepBlue rounded-2 group cursor-pointer',
      hasXLversion && '2xl:flex-col',
    ),
  image: 'w-full h-full flex-shrink-0 rounded-0.5 overflow-hidden',
  imageOverlay: (isActive: boolean) =>
    cls(
      'absolute top-0 h-full w-full bg-black opacity-70 z-40',
      isActive ? 'visible' : 'invisible group-hover:visible',
    ),
  logoWrapper: (hasRoundedLogo: boolean, hasXLversion: boolean) =>
    cls(
      ' relateive h-16 w-16 shrink-0 overflow-hidden relative z-0',
      hasRoundedLogo ? 'rounded-full' : 'rounded-1',
      hasXLversion && '2xl:h-38 2xl:w-38',
    ),
  logoPlaceholder: 'w-full h-full bg-black-light',
  icon: 'w-full h-full text-white',
  textWrapper: (hasXLversion: boolean) =>
    cls(
      'flex-col mx-4 overflow-hidden',
      hasXLversion && '2xl:text-center 2xl:mt-4',
    ),
  textPrimary: 'text-body2 font-semibold whitespace-nowrap',
  textSecondary: (hasXLversion: boolean) =>
    cls(
      'text-overline text-gray-4 teair:text-air-skyBlue line-clamp-2',
      hasXLversion && '2xl:mt-2',
    ),
  playPauseButton: (isActive: boolean, hasXLversion: boolean) =>
    cls(
      'absolute top-0 bottom-0 right-0 left-0 m-auto w-6 h-6 group-hover:visible z-50',
      isActive ? 'visible' : 'invisible',
      hasXLversion && '2xl:h-10 2xl:w-10',
    ),
};

export default styles;
